import './MeanAHI.scss';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import HorizontalBar from 'components/horizontal-bar';
import StyledCard from 'components/styled-card';
import { NightlyResponse } from 'types/hcp/pdfreport.type';
import { computeAHICategory, formatAHI } from 'utils/hcp/report/report.helper';

const data = [
  {
    max: 5,
    min: 0,
    color: '#5B8C00',
  },
  {
    max: 15,
    min: 5,
    color: '#FFC53D',
  },
  {
    max: 30,
    min: 15,
    color: '#F87415',
  },
  {
    max: 1000,
    min: 30,
    color: '#A8071A',
  },
];

const MeanAHI = ({ score, nightly }: { score: string; nightly: NightlyResponse }) => {
  const { t } = useTranslation();
  return (
    <StyledCard
      id="mean-ahi"
      title={
        <div className="ahititle">
          <div>{t('summary.ahi-label')}</div>
          {formatAHI(score === '3' ? nightly?.variables?.AHI : nightly?.variables?.AHI4) && (
            <div
              id="ahi-value"
              style={{
                fontSize: '18px',
                color: data?.find(
                  (el) =>
                    Number.parseFloat(
                      score === '3' ? nightly?.variables?.AHI : nightly?.variables?.AHI4
                    ) <= el.max &&
                    Number.parseFloat(
                      score === '3' ? nightly?.variables?.AHI : nightly?.variables?.AHI4
                    ) > el.min
                )?.color,
              }}>
              {formatAHI(score === '3' ? nightly?.variables?.AHI : nightly?.variables?.AHI4)}
            </div>
          )}
        </div>
      }>
      <div>
        <Row gutter={[16, 16]}>
          <Col xs={{ span: 24 }} md={{ span: 12 }} xl={{ span: 12 }}>
            <div style={{ maxWidth: '360px' }}>
              <HorizontalBar
                label={nightly?.variables?.AHICategory}
                value={formatAHI(
                  score === '3' ? nightly?.variables?.AHI : nightly?.variables?.AHI4
                )}
              />
            </div>
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 11, offset: 1 }} xl={{ span: 11, offset: 1 }}>
            {nightly?.settings?.showAhiCategory && (
              <Row gutter={[16, 16]}>
                <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 14 }} xl={{ span: 14 }}>
                  {t('nightly.ahi-category')}
                </Col>
                <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 10 }} xl={{ span: 10 }}>
                  {score === '3'
                    ? nightly?.variables?.AHICategory
                    : computeAHICategory(nightly?.variables?.AHI4)}
                </Col>
              </Row>
            )}
            <Row gutter={[16, 16]}>
              <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 14 }} xl={{ span: 14 }}>
                {t('nightly.ahi')}
              </Col>
              <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 10 }} xl={{ span: 10 }}>
                {formatAHI(score === '3' ? nightly?.variables?.AHI : nightly?.variables?.AHI4)}
              </Col>
            </Row>
            {nightly?.settings?.showcAHI && (
              <Row gutter={[16, 16]}>
                <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 14 }} xl={{ span: 14 }}>
                  {t('summary.cahi-10')}
                </Col>
                <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 10 }} xl={{ span: 10 }}>
                  {nightly?.variables?.AHIcFlag ? t('yes') : t('no')}
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </div>
    </StyledCard>
  );
};

export default MeanAHI;
